import { render, staticRenderFns } from "./MarkdownPreview.vue?vue&type=template&id=0b9bc23f&"
import script from "./MarkdownPreview.vue?vue&type=script&lang=ts&"
export * from "./MarkdownPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports